import {inlineError} from '@s-ui/decorators'

import {UnreadMessagesValueObject} from '../ValueObjects/UnreadMessagesValueObject.js'
import NotificationsRepository from './NotificationsRepository.js'

/**
 * @class
 * @implements NotificationsRepository
 */
export default class HTTPNotificationsRepository extends NotificationsRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {Repository} deps.cookieRepository
   * @param {Fetcher} deps.fetchOrFail
   * @param {Function} deps.log
   * @param {ValueObjectsFactory} deps.pendingPtaVOFactory
   * @param {ValueObject} deps.unreadMessagesValueObject
   * @param {UserEntity} deps.userEntity
   *
   */
  constructor({config, cookieRepository, fetchOrFail, log, pendingPtaVOFactory, userEntity}) {
    super()

    this._config = config
    this._userEntity = userEntity
    this._fetchOrFail = fetchOrFail
    this._cookieRepository = cookieRepository
    this._log = log
    this._pendingPtaVOFactory = pendingPtaVOFactory
    this._apiUrl = this._config.get('API_URL')
  }

  /**
   *
   * @return {Promise<http-header>}
   */
  async sendEmailValidation() {
    const userId = this._userEntity.getId()

    const [error] = await this._fetchOrFail
      .withErrorsFactories()
      .post(`${this._apiUrl}/users/${userId}/send-verification`)

    if (error) return Promise.reject(error)

    return true
  }

  /**
   * Endpoint returns 204 in case there is no pending PTA
   * @return {Promise<PendingPtaValueObject>}
   */
  async getPendingPta() {
    this._log('Retrieving pendings PTA')

    const userId = this._userEntity.getId()

    const [error, response] = await this._fetchOrFail
      .withErrorsFactories()
      .get(`${this._apiUrl}/users/${userId}/pending-ad`)

    if (error) return Promise.reject(error)

    const {
      status,
      data: {adId}
    } = response

    return status === 200 && adId
      ? this._cookieRepository.setPendingPta({adId}).then(() => this._pendingPtaVOFactory({pendingPta: 1}))
      : Promise.reject(new Error('HTTPNotificationsRepository: No pending PTA found.'))
  }

  /**
   * @return {Promise<Number>}
   */

  @inlineError
  async getUnreadMessages({userEntity}) {
    this._log('Retrieving unread messages')
    const userId = userEntity.getId()

    const [error, response] = await this._fetchOrFail
      .withErrorsFactories()
      .get(`${this._apiUrl}/users/${userId}/messages/unread-count`)

    if (error) return Promise.reject(error)

    const {
      data: {count}
    } = response

    return UnreadMessagesValueObject.create({unreadMessages: count})
  }
}
